import { render, staticRenderFns } from "./AddSettlementModal.vue?vue&type=template&id=0168e4d2&scoped=true"
import script from "./AddSettlementModal.vue?vue&type=script&lang=js"
export * from "./AddSettlementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168e4d2",
  null
  
)

export default component.exports